import React from "react";
import { LazyAutoplayVideo } from "../../visuals/LazyAutoplayVideo";
import { Box, Flex } from "@chakra-ui/react";
import { useLandingTheme } from "../../LandingThemeContext";
import { FigureLabel, SECTION_GAP, ThemedBody, ThemedContainer, ThemedDisplayTitle } from "./ThemedLayout";

const VIDEO_SRC = "https://d2hnj1wejf84km.cloudfront.net/grow-trees.mp4";

// The tree is the payoff: shown large, cropped to the jungle panel of the recording, copy anchored beside it.
// Themes without the mascot illustration tint the recording toward their own ink so it reads as the same hand.
export function ThemedProgress() {
  const theme = useLandingTheme();
  const tintToTheme = !theme.footer.showIllustration;
  return (
    <Box as="section" mt={SECTION_GAP}>
      <ThemedContainer>
        <Flex direction={{ base: "column", lg: "row" }} align="center" gap={{ base: "40px", lg: "88px" }}>
          <Box
            position="relative"
            flexShrink={0}
            w={{ base: "300px", md: "380px" }}
            h={{ base: "540px", md: "680px" }}
            borderRadius={theme.shape.cardRadius}
            overflow="hidden"
            border={theme.card.border}
            boxShadow={theme.card.shadow}
          >
            <LazyAutoplayVideo
              src={VIDEO_SRC}
              poster="/images/landing/grow-trees-poster.webp"
              style={{
                width: "100%",
                height: "100%",
                display: "block",
                objectFit: "cover",
                objectPosition: "100% 50%",
                filter: tintToTheme
                  ? theme.isDark
                    ? "grayscale(1) contrast(1.05) brightness(0.5)"
                    : "grayscale(1) contrast(1.05)"
                  : "none",
              }}
            />
            {/* Light themes multiply the ink over the greys; dark themes recolor with the hue and keep the luminance. */}
            {tintToTheme && (
              <Box
                aria-hidden="true"
                position="absolute"
                inset={0}
                bg={theme.isDark ? theme.color.accentDark : theme.color.accent}
                mixBlendMode={theme.isDark ? "color" : "multiply"}
                opacity={theme.isDark ? 1 : 0.85}
                pointerEvents="none"
              />
            )}
          </Box>
          <Box flex="1" minW={0}>
            <FigureLabel figureNumber={5} label="Progress" />
            <ThemedDisplayTitle>Grow a tree as you learn.</ThemedDisplayTitle>
            <ThemedBody mt="16px" maxW="440px">
              Every answer grows your tree, so a study session leaves something behind — and a missed day shows.
            </ThemedBody>
          </Box>
        </Flex>
      </ThemedContainer>
    </Box>
  );
}
